module.exports = __webpack_public_path__ + "static/media/background.21b9ece7.jpg";